import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Loader from "../Loader/Loader";
import { makeStyles } from '@material-ui/core/styles';
import StarIcon from "@material-ui/icons/Star";
import MapView from "./components/MapView";
import logo from './image.jpeg'

const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 1,
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 1,
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 1,
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
    }
};

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    mapView: {
        [theme.breakpoints.up("sm")]: {
            position: 'fixed',
            width: '100%',
            right: '0px'
        }
      },
}));



export default function HotelProperties(props) {
    const [activeIndex, setActiveIndex] = useState(0)
    const classes = useStyles();
    const search = useLocation().search;
    const searchParam = new URLSearchParams(search);
    const check_in_date = searchParam.get("check_in_date");
    const check_out_date = searchParam.get("check_out_date");
    const location = searchParam.get("location");
    const adult_count = searchParam.get("adult_count")
    const child_count = searchParam.get("child_count")
    const source_market = searchParam.get("source_market");
    const room_count = searchParam.get("room_count");
    const currency = searchParam.get("currency");

    const [hotels, setHotels] = useState([])
    const [markers, setMarkers] = useState([])
    const [loading, setLoading] = useState(false)

    const searchHotels = async () => {
        if (!check_in_date || !check_out_date || !location || !adult_count)
            return;
        setLoading(true);
        var queryParam = `hotels/search-dida-hotel-properties?check_in_date=${check_in_date}&child_count=${child_count}&check_out_date=${check_out_date}&location=${location}&adult_count=${adult_count}&source_market=${source_market}&room_count=${room_count}`;


        if (currency) queryParam += `&currency=${currency}`;

        let response2 = await axios.get(queryParam);
        setLoading(false);
        if (response2 && response2.data && response2.data.data) {
            var data = response2.data.data;
            // if (data.status !== 'complete') {
            //     setTimeout(searchHotels, 3000)
            // } else {
                
            // }
            if (data && data.Success) {
                let d = data.Success.PriceDetails.HotelList
                d = d.filter((d)=> {
                    if(d.meta_data){
                        return true
                    }
                    return false
                })
                setHotels(d);
                let _markers = d.map(item => ({ id: item.meta_data?.HotelID, title: item.meta_data?.Name, lat: parseFloat(item.meta_data.Latitude), lng: parseFloat(item.meta_data.Longitude) }));
                setMarkers(_markers);
            }
        }

    };

    useEffect(() => {
        searchHotels()
    }, [])

    const getImageUrl = (data) => {
        if (data.links.m) {
            return data.links?.m?.href
        } else if (data.links.s) {
            return data.links.s.href
        } else if (data.links.l) {
            return data.links.l.href
        }
        return ''
    }

    const getImage = (meta_data) => {
        if (meta_data.hero_images && meta_data.hero_images.length > 0) {
            if (meta_data?.hero_images[0].links.m) {
                return meta_data?.hero_images[0].links?.m?.href
            } else if (meta_data?.hero_images[0].links.s) {
                return meta_data?.hero_images[0].links.s.href
            } else if (meta_data?.hero_images[0].links.l) {
                return meta_data?.hero_images[0].links.l.href
            }
        } else if (meta_data.images && meta_data.images.length > 0) {
            let url = ''
            meta_data.images.map((im) => {
                if (im.hero_image) {
                    if (im.links.m) {
                        url = im.links?.m?.href
                    } else if (im.links.s) {
                        url = im.links.s.href
                    } else if (im.links.l) {
                        url = im.links.l.href
                    }
                }
            })
            if (url == '') {
                if (meta_data.images[0].links.m) {
                    url = meta_data.images[0].links?.m?.href
                } else if (meta_data.images[0].links.s) {
                    url = meta_data.images[0].links.s.href
                } else if (meta_data.images[0].links.l) {
                    url = meta_data.images[0].links.l.href
                }
            }
            return url
        }
        return ''
    }

    const navigateToRooms = (id) => {
        let url = `/hotels/search-hotel-rooms?id=${id}&child_count=${child_count}&check_in_date=${check_in_date}&check_out_date=${check_out_date}&location=${location}&adult_count=${adult_count}&source_market=${source_market}&room_count=${room_count}`;


        if (currency) url += `&currency=${currency}`
        props.history.push(url)
    }


    return (<div className={classes.root} style={{ backgroundColor: "var(--white)", color: "var(--white)", padding: '42px', paddingTop: '110px' }}>
        <Grid container spacing={2}>
            <Grid item xs={12} sm={5}>
                <Grid container spacing={2}>
                    {hotels.map((hotel, index) => {
                        return <Grid item xs={12} sm={6} 
                        onClick={()=>navigateToRooms(hotel.HotelID)} 
                        onMouseEnter={() => setActiveIndex(index)} onMouseLeave={() => setActiveIndex(-1)} style={{cursor: 'pointer'}}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Carousel partialVisible={true}
                                        responsive={responsive}
                                    >{hotel.meta_data && hotel.meta_data.Images ? hotel.meta_data.Images.map((im) => {
                                        return <img style={{ borderRadius: '12px', objectFit: 'cover' }} width="100%" height="250" src={im.ImageUrl} />
                                    }) : <img style={{ borderRadius: '12px', objectFit: 'cover' }} width="100%" height="250"  src={logo} />}
                                    </Carousel>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={10}>
                                            <Typography component="p" className="hotel-name clipped-label text-left">
                                                {hotel?.meta_data?.Name}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Typography component="p" className="text-right">
                                                {hotel?.meta_data?.StarRating}{" "}
                                                <StarIcon style={{ color: "var(--green)", fontSize: "20px", marginTop: '-5px' }} />
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography component="p" className="text-left">
                                                {hotel?.meta_data?.Address}{" "}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography component="p" className="text-left">
                                                <b>{hotel?.LowestPrice?.Currency} {hotel?.LowestPrice?.Value}</b> Night
                                            </Typography>
                                        </Grid>

                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    })}
                </Grid>

            </Grid>
            <Grid item xs={12} sm={7} className={classes.mapView}>
                {markers &&
                    markers.length > 0 && <MapView markers={markers} selectedMarker={activeIndex >=0 ? markers[activeIndex] : null} />}
            </Grid>
        </Grid>
        <Loader show={loading} />
    </div>)

}